<!-- Header -->
<tgx-onboarding-company-header
  [loggedUser]="loggedUser"
  [companyName]="companyName"
  [userImg]="userImg"
  [isBuyer]="isBuyer"
  [isSeller]="isSeller"
></tgx-onboarding-company-header>

@if (!isLoading) {
  <div>
    <div class="container">
      <!-- Progress bar -->
      <tgx-onboarding-company-progressbar-steps
        [steps]="steps"
        [isBuyer]="isBuyer"
        [isSeller]="isSeller"
      ></tgx-onboarding-company-progressbar-steps>

      <!-- STEP 1  professional details-->
      @if (steps.get(Steps.DETAILS)?.actualStep) {
        <tgx-onboarding-company-professional-details
          [loggedUser]="loggedUser"
          [selectedOrg]="selectedOrg"
          [jobTitle]="jobTitle"
          [companyName]="companyName"
          (changeStep)="changeStep($event)"
        ></tgx-onboarding-company-professional-details>
      }

      <!-- STEP 2 company contacts-->
      @if (steps.get(Steps.COMPANY_CONTACTS)?.actualStep) {
        <tgx-onboarding-company-company-contacts
          [isBuyer]="isBuyer"
          [selectedOrgCode]="$safeNavigationMigration(selectedOrg?.code)"
          [orgMembersProfiles]="orgMembersProfiles"
          [isSeller]="isSeller"
          [loggedUser]="loggedUser"
          (changeStep)="changeStep($event)"
          (updateUserProfile)="updateUserProfile($event)"
        ></tgx-onboarding-company-company-contacts>
      }

      <!-- STEP 3 Billing information-->
      @if (steps.get(Steps.BILLING)?.actualStep) {
        <tgx-onboarding-company-billing
          (changeStep)="changeStep($event)"
          [isBuyer]="isBuyer"
          [isSeller]="isSeller"
          [selectedOrg]="selectedOrg"
          (updateUserProfile)="updateUserProfile($event)"
        ></tgx-onboarding-company-billing>
      }

      <!-- STEP 4 review and confirm -->
      @if (steps.get(Steps.REVIEW)?.actualStep) {
        <tgx-onboarding-company-review
          [isBuyer]="isBuyer"
          [isSeller]="isSeller"
          (changeStep)="changeStep($event)"
          [loggedUser]="loggedUser"
          [selectedOrg]="selectedOrg"
          [jobTitle]="jobTitle"
          [companyName]="companyName"
          (updateUserProfile)="updateUserProfile($event)"
        >
        </tgx-onboarding-company-review>
      }

      <!-- STEP 5  finish message-->
      @if (steps.get(Steps.CONFIRM)?.actualStep) {
        <tgx-onboarding-company-finish
          [isBuyer]="isBuyer"
          [isSeller]="isSeller"
          [isSellerPush]="isSellerPush"
        ></tgx-onboarding-company-finish>
      }
    </div>
  </div>
}

<!-- Skeleton -->
@if (isLoading) {
  <div class="container">
    <div class="mt-5">
      <p-skeleton class="mb-5" />
      <p-skeleton width="16rem" height="2rem" class="mb-5" />
      <div class="row">
        <div class="col d-flex flex-column gap-4">
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" height="25px" />
            <p-skeleton width="20rem" />
          </div>
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" height="25px" />
            <p-skeleton width="20rem" />
          </div>
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" height="25px" />
            <p-skeleton width="20rem" />
          </div>
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" height="25px" />
            <p-skeleton width="20rem" />
          </div>
        </div>
        <div class="col d-flex flex-column gap-4">
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" />
            <p-skeleton width="100%" height="2rem" />
          </div>
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" />
            <p-skeleton width="100%" height="2rem" />
          </div>
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" />
            <p-skeleton width="100%" height="2rem" />
          </div>
          <div class="col d-flex flex-column gap-2">
            <p-skeleton width="12rem" />
            <p-skeleton width="100%" height="2rem" />
          </div>
        </div>
      </div>
    </div>
  </div>
}
